import upload_area from './../assets/upload_area.png';
//  vedpathshala 
import  ved_img_1 from "./vedpathshala/img_1.jpg";
import  ved_img_2 from './vedpathshala/img02.JPG';
import  ved_img_3 from './vedpathshala/img03.jpg';
import ved_img_4 from  './vedpathshala/img1.jpg';
import ved_img_5 from './vedpathshala/img2.jpg';
// Goshala 
import g_img_1 from "./goshalaImg/img03.JPG"
import   g_img_2 from "./goshalaImg/गोशाला महत्व .JPG"
//sansthan
import s_img01 from  "./sansthan/संस्थान १ .jpg";
import s_img02 from "./sansthan/sansthan karya parampara.jpg";
import s_img04 from "./sansthan/varshik.jpg";
import s_img03 from "./sansthan/img03.jpg"
import s_img05 from "./sansthan/img05.jpg";
import s_img06 from "./sansthan/img06.jpg";
import s_img07 from "./sansthan/महाशिवरात्र .JPG";
import s_img08 from "./sansthan/img08.JPG";
import s_img09 from "./sansthan/द्वादशी व्रत .JPG"
import nityopasana from "./sansthan/नित्यउपासना .JPG"
import parampara from "./sansthan/परंपरा .JPG"
import pujavidhi from "./sansthan/पूजाविधी .JPG"

//daji maharaj
import d_img01 from "./dajiMaharajImg/dajimaharaj.jpg";
import d_img03 from "./dajiMaharajImg/img03.jpg";
import d_img04 from "./dajiMaharajImg/daji12.jpg";

//gangaji
import g_img01 from "./gangajiBapuImg/img01.JPG"

//comman 
import com_publication from "./commonImg/publication.JPG";

import com_sevamandal from "./commonImg/sevamandal.jpg"

import com_upkarm from "./commonImg/वेदपाठशाला अंतर्गत उपक्रम .JPG";


export const assets ={   
    upload_area,    
}



export const commonImg = {
    com_publication,
    com_sevamandal,
    com_upkarm
}
export const gangajiBabuImg = {
    g_img01
}
export const vedpathshalaImg ={
    ved_img_1,
    ved_img_2,
    ved_img_3,
    ved_img_4,
    ved_img_5

}

// shi daji maharaj 
export const shriDajiMahaImg ={
    d_img01,
    d_img03,
    d_img04
}


// Goshala 
export const goshalaImg={
    g_img_1,
    g_img_2

}

// sansthan 
export const sansthanImg ={
  s_img01,  
 s_img04,
 s_img02,
  s_img05,
 s_img06,
 s_img07,
 s_img08,
 s_img03,
 s_img09,
 nityopasana,
 parampara,
 pujavidhi
}

